/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Action from './Action/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Action1({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda/Appointments/Content/Appointment/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedIsHoveredValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'is_hovered',
})
let selectedIsSubmittingValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'is_submitting',
})
let aggregateData = fromHelpers.getView(selectedIsHoveredValueData, selectedIsSubmittingValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Action'}>
<Action
  viewPath={`${viewPath}/Action`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}